import CmsContentPage from "./CmsContentPage";

const FALLBACK =
  "https://images.pexels.com/photos/6872600/pexels-photo-6872600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const EventsPage = () => (
  <CmsContentPage
    pageKey="events"
    fallbackHero={FALLBACK}
    dataTestId="events-page"
  />
);

export default EventsPage;
